module.exports = __webpack_public_path__ + "img/icon_chip_06.6272d64d.png";